import { render, staticRenderFns } from "./LogoutIcon.vue?vue&type=template&id=0bac415b&scoped=true&"
import script from "./LogoutIcon.vue?vue&type=script&lang=ts&"
export * from "./LogoutIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bac415b",
  null
  
)

export default component.exports